import './css/App.css';
import Header from './components/header.js';
import Page1 from './pages/page1.js';
import Page2 from './pages/page2.js';
import Page3 from './pages/page3.js';
import Page4 from './pages/page4.js';
import Page5 from './pages/page5.js';
import Page6 from './pages/page6.js';
import Page7 from './pages/page7.js';
import Footer from './components/footer.js';

function App() {
  return (
    <div className="App">
      <title>Pathway AI</title>
      <Header />
      <div>
        <div
          className="graphic"
        />
          <Page1 />
          <Page2 />
          <Page3 />
          <Page4 />
          <Page5 />
          <Page6 />
          <Page7 />
        </div>
      <Footer/>
    </div>
  );
}

export default App;
